import { useNavigate, useLocation } from 'react-router-dom';
import IconHome from '../assets/icon-home.webp';
import IconLootbox from '../assets/icon-lootbox.webp';
import IconEcosystem from '../assets/icon-ecosystem.webp';
import IconQuest from '../assets/icon-quest.webp';
import IconWallet from '../assets/icon-wallet.webp';


const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/ecosystem', label: 'Ecosystem', image: IconEcosystem },
    // { path: '/quests', label: 'Quests', image: IconQuest },
    { path: '/', label: 'Home', image: IconHome },
    { path: '/lootbox', label: 'Lootbox', image: IconLootbox },
    // { path: '/wallet', label: 'Wallet', image: IconWallet },
  ];

  return (
    <div id="navigation" className="fixed bottom-0 w-full px-4 py-2 max-w-[500px] mx-auto -translate-x-1/2 left-1/2">
      <div className="flex justify-between items-end px-4 bg-[#9747ff61]  rounded-3xl gap-3 backdrop-blur">
        {navItems.map((item) => (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center font-bold p-2 transition-all my-1 relative pb-4 ${location.pathname === item.path
              ? 'text-white bg-black bg-opacity-30 rounded-xl'
              : 'text-[9747ff61]'
              }`}
          >
            <img className='w-12' src={item.image} alt={item.label} />
            <span className={`text-xs absolute bottom-1 transition-all ${location.pathname === item.path
              ? 'scale-100'
              : 'scale-80'
              }`}>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Navigation;  
